import React from 'react'
import AllRidesMainComp from '../../components/body/alldatacomponent/rides/allridesmaincomp'
import NavbarComp from '../../components/navbar/navbar'
import SidebarComp from '../../components/sidebar/sidebar'

const AddRideScreen = () => {
    return (
        <div className="container-scroller">
            <NavbarComp />
            <div className="container-fluid page-body-wrapper">
                <SidebarComp />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <AllRidesMainComp />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddRideScreen